import { render, staticRenderFns } from "./ModalAuditAutomaticNotification.vue?vue&type=template&id=483787ed&scoped=true"
import script from "./ModalAuditAutomaticNotification.vue?vue&type=script&lang=ts"
export * from "./ModalAuditAutomaticNotification.vue?vue&type=script&lang=ts"
import style0 from "./ModalAuditAutomaticNotification.vue?vue&type=style&index=0&id=483787ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483787ed",
  null
  
)

export default component.exports